export default {
  BASE_URL: 'https://mall-api.kilitest.com',
  LOCAL_BASE_URL: 'http://marketplace-k-b2c-buyer-api.mkp-2c',
  AUTHORIZE_BASE_URL: 'http://psms-member-svc.mkt',
  FILE_URL: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test',
  OLD_WAP_URL: 'https://h5-lite.kilitest.com',
  SOCKET_URL: 'https://chat-api.kilitest.com',
  EBES_B2C_AWS_S3_OFS_URL: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/ofs-test',
  REVIEWS_URL: 'https://java-gw.kilitest.com',
  EBES_B2C_AWS_S3_MEDIA: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/',
  SENSORS_URL: 'https://kilidata.kilimall.com/sa?project=test',
  AFTER_SALE_URL: 'https://aftersale-api.kilitest.com',
  K_URL: 'https://m.kilitest.com',
  EXPRESS_URL: 'https://express-gw.kilitest.com',
  EBES_B2C_AWS_S3_MEDIA_LITE: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/lite-test',
  S3_IMAGE_URL: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/lite-test',
  MARKETING_URL: 'https://gw-lite.kilitest.com/',

  AFTERSALE_KONG_URL: 'https://aftersale.api.kilitest.com',
  OLD_K_URL: 'https://m.kilitest.com',
  HW_OBS: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test',
  HW_OBS_UPLOAD: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com',
  SELLER_H5_URL: 'https://seller-gw.kilitest.com/',
  HW_OBS_STORE_CMS_URL: 'https://mkp-cn-testing.obs.cn-south-1.myhuaweicloud.com/c/test/seller/{storeId}/store_home/{countryCode}.json',

    // 收银台
  LIPAPAY_CASHIER: 'https://lipapay-cashier.kilitest.com',
  // 钱包
  LIPAPAY_WALLET: 'https://lipapay-wallet.kilitest.com',
  BI_URL: 'https://bi.kilitest.com',

  MERCHANT_ID: {
    KE: '2016051112014649173095',
    UG: '2016051112014649173096'
  }
}
